// import React, { useState, useEffect, useRef } from "react";
// import { MessageSquare, DollarSign, Wifi, Battery } from "lucide-react";
// import { generatePost } from "../lib/postGenerator";
// import "./SocialFeed.css";

// const POST_LIKELIHOOD = 0.5; // Odds of post each time interval
// const MAX_POSTS = 30; // Maximum number of posts to keep in feed

// const StatusBar = () => (
//   <div className="phone-status-bar">
//     <div className="status-left">
//       <div className="signal-bars">
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar empty"></div>
//       </div>
//       <Wifi size={16} />
//     </div>
//     <div className="status-right">
//       <Battery size={16} />
//     </div>
//   </div>
// );

// const Post = ({ content, author, timestamp, isAd, sponsor }) => (
//   <div className={`social-post ${isAd ? "sponsored" : ""}`}>
//     {isAd && (
//       <div className="sponsor-label">
//         <DollarSign size={14} />
//         <span>Sponsored by {sponsor}</span>
//       </div>
//     )}
//     <div className="post-header">
//       <div className="post-author">{author}</div>
//     </div>
//     <div className="post-content">{content}</div>
//   </div>
// );

// const SocialFeed = ({ gameState }) => {
//   const [posts, setPosts] = useState([]);
//   const feedContentRef = useRef(null);

//   // Add new posts periodically
//   useEffect(() => {
//     if (!gameState) return;
//     // Generate a new post if the odds are met
//     const postLikelihood =
//       gameState.userCount <= 0
//         ? 0
//         : Math.min(1, (Math.log10(gameState.userCount) - 3) * 0.4 + 0.2);
//     if (Math.random() < postLikelihood) {
//       const newPost = generatePost(gameState);
//       setPosts((currentPosts) => {
//         // Add new post at the beginning and limit total number
//         const updatedPosts = [newPost, ...currentPosts].slice(0, MAX_POSTS);
//         return updatedPosts;
//       });
//     }
//   }, [gameState]);

//   // Scroll to top when new posts are added
//   useEffect(() => {
//     if (feedContentRef.current) {
//       const scrollOptions = {
//         top: 0,
//         behavior: "smooth",
//       };
//       feedContentRef.current.scrollTo(scrollOptions);
//       const scrollHack = {
//         top: 1,
//         behavior: "smooth",
//       };
//       feedContentRef.current.scrollTo(scrollHack);
//     }
//   }, [posts]);

//   return (
//     <div className="phone-container">
//       <div className="phone-notch"></div>
//       <StatusBar />
//       <div className="phone-screen">
//         <div className="social-feed">
//           <div className="feed-header">
//             <MessageSquare size={20} />
//             <h2>Social Feed</h2>
//           </div>
//           <div className="feed-content" ref={feedContentRef}>
//             {posts.map((post) => (
//               <Post key={post.id} {...post} />
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SocialFeed;

// import React, { useState, useEffect, useRef, memo } from "react";
// import {
//   MessageSquare,
//   DollarSign,
//   Wifi,
//   Battery,
//   Heart,
//   MessageCircle,
//   Repeat2,
// } from "lucide-react";
// import { generatePost } from "../lib/postGenerator";
// import "./SocialFeed.css";

// const MAX_POSTS = 30;

// const StatusBar = () => (
//   <div className="phone-status-bar">
//     <div className="status-left">
//       <div className="signal-bars">
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar empty"></div>
//       </div>
//       <Wifi size={16} />
//     </div>
//     <div className="status-right">
//       <Battery size={16} />
//     </div>
//   </div>
// );

// const PostEngagement = memo(({ likes, shares, comments }) => {
//   const formatNumber = (num) => {
//     if (num >= 1000000) {
//       return (num / 1000000).toFixed(1) + "m";
//     } else if (num >= 1000) {
//       return (num / 1000).toFixed(1) + "k";
//     }
//     return num;
//   };

//   return (
//     <div className="post-engagement">
//       <div className="engagement-stat">
//         <Heart size={16} />
//         <span>{formatNumber(likes)}</span>
//       </div>
//       <div className="engagement-stat">
//         <MessageCircle size={16} />
//         <span>{formatNumber(comments)}</span>
//       </div>
//       <div className="engagement-stat">
//         <Repeat2 size={16} />
//         <span>{formatNumber(shares)}</span>
//       </div>
//     </div>
//   );
// });

// const Post = memo(({ content, author, isAd, sponsor, userCount }) => {
//   const [engagement, setEngagement] = useState(() => {
//     // Helper function to generate Poisson distributed number
//     const poissonRandom = (lambda) => {
//       let L = Math.exp(-lambda);
//       let k = 0;
//       let p = 1;

//       do {
//         k++;
//         p *= Math.random();
//       } while (p > L);

//       return k - 1;
//     };

//     // Calculate base engagement rate that's higher for smaller user bases
//     const baseEngagementRate = isAd
//       ? 0.00005
//       : Math.min(0.1, 1 / Math.sqrt(userCount));

//     // Mean likes based on user count and engagement rate
//     const meanLikes = userCount * baseEngagementRate;

//     // Generate likes using Poisson distribution
//     const baseLikes = poissonRandom(meanLikes);

//     // Comments and shares are also Poisson distributed
//     const commentLambda = Math.max(baseLikes * 0.1, 0.1);
//     const shareLambda = Math.max(baseLikes * 0.05, 0.05);

//     return {
//       likes: baseLikes,
//       comments: poissonRandom(commentLambda),
//       shares: poissonRandom(shareLambda),
//     };
//   });

//   // Update engagement numbers periodically
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setEngagement((prev) => {
//         const growthRate = 1 + Math.random() * 0.01; // 0-1% increase
//         return {
//           likes: Math.floor(prev.likes * growthRate),
//           comments: Math.floor(prev.comments * growthRate),
//           shares: Math.floor(prev.shares * growthRate),
//         };
//       });
//     }, 5000); // Update every 5 seconds

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className={`social-post ${isAd ? "sponsored" : ""}`}>
//       {isAd && (
//         <div className="sponsor-tag">
//           <DollarSign size={14} />
//           <span>Sponsored by {sponsor}</span>
//         </div>
//       )}
//       <div className="post-header">
//         <div className="post-author">{author}</div>
//       </div>
//       <div className="post-content">{content}</div>
//       <PostEngagement {...engagement} />
//     </div>
//   );
// });

// const SocialFeed = ({ gameState }) => {
//   const [posts, setPosts] = useState([]);
//   const [lastPostTime, setLastPostTime] = useState(Date.now());
//   const feedContentRef = useRef(null);

//   // Add new posts periodically
//   useEffect(() => {
//     const postInterval = setInterval(() => {
//       if (!gameState) return;

//       const currentTime = Date.now();
//       const timeSinceLastPost = currentTime - lastPostTime;

//       // Only attempt to post if at least 1000ms (1 second) has passed
//       if (timeSinceLastPost >= 1000) {
//         // Calculate post likelihood based on user count
//         const postLikelihood =
//           gameState.userCount <= 0
//             ? 0
//             : Math.min(1, (Math.log10(gameState.userCount) - 3) * 0.4 + 0.2);

//         // Generate a new post if the odds are met
//         if (Math.random() < postLikelihood) {
//           const newPost = generatePost(gameState);

//           // Add new post with smooth transition
//           requestAnimationFrame(() => {
//             setPosts((currentPosts) => {
//               const newPosts = [newPost, ...currentPosts].slice(0, MAX_POSTS);

//               // Smoothly scroll to top if we're near the top
//               if (
//                 feedContentRef.current &&
//                 feedContentRef.current.scrollTop < 100
//               ) {
//                 feedContentRef.current.scrollTo({
//                   top: 0,
//                   behavior: "smooth",
//                 });
//                 feedContentRef.current.scrollTo({
//                   top: 1,
//                   behavior: "smooth",
//                 });
//               }

//               return newPosts;
//             });
//           });

//           setLastPostTime(currentTime);
//         }
//       }
//     }, 100);

//     return () => clearInterval(postInterval);
//   }, [gameState, lastPostTime]);

//   return (
//     <div className="phone-container">
//       <div className="phone-notch"></div>
//       <StatusBar />
//       <div className="phone-screen">
//         <div className="social-feed">
//           <div className="feed-header">
//             <MessageSquare size={20} />
//             <h2>Social Feed</h2>
//           </div>
//           <div className="feed-content" ref={feedContentRef}>
//             {posts.map((post) => (
//               <Post key={post.id} {...post} userCount={gameState.userCount} />
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SocialFeed;

// import React, { useState, useEffect, useRef, memo } from "react";
// import {
//   MessageSquare,
//   DollarSign,
//   Wifi,
//   Battery,
//   Heart,
//   MessageCircle,
//   Repeat2,
// } from "lucide-react";
// import { generatePost } from "../lib/postGenerator";
// import "./SocialFeed.css";

// const MAX_POSTS = 30;

// const StatusBar = () => (
//   <div className="phone-status-bar">
//     <div className="status-left">
//       <div className="signal-bars">
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar"></div>
//         <div className="bar empty"></div>
//       </div>
//       <Wifi size={16} />
//     </div>
//     <div className="status-right">
//       <Battery size={16} />
//     </div>
//   </div>
// );

// const PostEngagement = memo(({ likes, shares, comments }) => {
//   const formatNumber = (num) => {
//     if (num >= 1000000) {
//       return (num / 1000000).toFixed(1) + "m";
//     } else if (num >= 1000) {
//       return (num / 1000).toFixed(1) + "k";
//     }
//     return num;
//   };

//   return (
//     <div className="post-engagement">
//       <div className="engagement-stat">
//         <Heart size={16} />
//         <span>{formatNumber(likes)}</span>
//       </div>
//       <div className="engagement-stat">
//         <MessageCircle size={16} />
//         <span>{formatNumber(comments)}</span>
//       </div>
//       <div className="engagement-stat">
//         <Repeat2 size={16} />
//         <span>{formatNumber(shares)}</span>
//       </div>
//     </div>
//   );
// });

// const Post = memo(({ content, author, isAd, sponsor, userCount }) => {
//   const [engagement, setEngagement] = useState(() => {
//     // Helper function to generate Poisson distributed number
//     const poissonRandom = (lambda) => {
//       let L = Math.exp(-lambda);
//       let k = 0;
//       let p = 1;

//       do {
//         k++;
//         p *= Math.random();
//       } while (p > L);

//       return k - 1;
//     };

//     // Calculate base engagement rate that's higher for smaller user bases
//     const baseEngagementRate = isAd
//       ? 0.00005
//       : Math.min(0.1, 1 / Math.sqrt(userCount));

//     // Mean likes based on user count and engagement rate
//     const meanLikes = userCount * baseEngagementRate;

//     // Generate likes using Poisson distribution
//     const baseLikes = poissonRandom(meanLikes);

//     // Comments and shares are also Poisson distributed
//     const commentLambda = Math.max(baseLikes * 0.1, 0.1);
//     const shareLambda = Math.max(baseLikes * 0.05, 0.05);

//     return {
//       likes: baseLikes,
//       comments: poissonRandom(commentLambda),
//       shares: poissonRandom(shareLambda),
//     };
//   });

//   // Update engagement numbers periodically
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setEngagement((prev) => {
//         const growthRate = 1 + Math.random() * 0.01; // 0-1% increase
//         return {
//           likes: Math.floor(prev.likes * growthRate),
//           comments: Math.floor(prev.comments * growthRate),
//           shares: Math.floor(prev.shares * growthRate),
//         };
//       });
//     }, 5000); // Update every 5 seconds

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className={`social-post ${isAd ? "sponsored" : ""}`}>
//       {isAd && (
//         <div className="sponsor-tag">
//           <DollarSign size={14} />
//           <span>Sponsored by {sponsor}</span>
//         </div>
//       )}
//       <div className="post-header">
//         <div className="post-author">{author}</div>
//       </div>
//       <div className="post-content">{content}</div>
//       <PostEngagement {...engagement} />
//     </div>
//   );
// });

// const SocialFeed = ({ gameState }) => {
//   const [posts, setPosts] = useState([]);
//   const [lastPostTime, setLastPostTime] = useState(Date.now());
//   const feedContentRef = useRef(null);

//   // Add new posts periodically
//   useEffect(() => {
//     const postInterval = setInterval(() => {
//       if (!gameState) return;

//       const currentTime = Date.now();
//       const timeSinceLastPost = currentTime - lastPostTime;

//       if (timeSinceLastPost >= 1000) {
//         const postLikelihood =
//           gameState.userCount <= 0
//             ? 0
//             : Math.min(1, (Math.log10(gameState.userCount) - 3) * 0.4 + 0.2);

//         if (Math.random() < postLikelihood) {
//           const newPost = generatePost(gameState);

//           if (feedContentRef.current && feedContentRef.current.scrollTop < 50) {
//             // First scroll down slightly to make room
//             feedContentRef.current.scrollTo({
//               top: 1,
//               behavior: "smooth",
//             });

//             // After a brief delay, add the post and scroll back up
//             setTimeout(() => {
//               setPosts((currentPosts) =>
//                 [newPost, ...currentPosts].slice(0, MAX_POSTS)
//               );

//               // After the post is added, scroll back to top
//               setTimeout(() => {
//                 feedContentRef.current?.scrollTo({
//                   top: 0,
//                   behavior: "smooth",
//                 });
//               }, 50);
//             }, 30);
//           } else {
//             // If we're scrolled down, just add the post without scrolling
//             setPosts((currentPosts) =>
//               [newPost, ...currentPosts].slice(0, MAX_POSTS)
//             );
//           }
//         }
//         setLastPostTime(currentTime);
//       }
//     }, 100);

//     return () => clearInterval(postInterval);
//   }, [gameState, lastPostTime]);

//   return (
//     <div className="phone-container">
//       <div className="phone-notch"></div>
//       <StatusBar />
//       <div className="phone-screen">
//         <div className="social-feed">
//           <div className="feed-header">
//             <MessageSquare size={20} />
//             <h2>Social Feed</h2>
//           </div>
//           <div className="feed-content" ref={feedContentRef}>
//             {posts.map((post) => (
//               <Post key={post.id} {...post} userCount={gameState.userCount} />
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SocialFeed;

import React, { useState, useEffect, useRef, memo } from "react";
import {
  DollarSign,
  Wifi,
  Battery,
  Heart,
  MessageCircle,
  Repeat2,
} from "lucide-react";
import { generatePost } from "../lib/postGenerator";
import "./SocialFeed.css";

const MAX_POSTS = 30;

const StatusBar = () => (
  <div className="phone-status-bar">
    <div className="status-left">
      <div className="signal-bars">
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar empty"></div>
      </div>
      <Wifi size={16} />
    </div>
    <div className="status-right">
      <Battery size={16} />
    </div>
  </div>
);

const PostEngagement = memo(({ likes, shares, comments }) => {
  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "m";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "k";
    }
    return num;
  };

  return (
    <div className="post-engagement">
      <div className="engagement-stat">
        <Heart size={16} />
        <span>{formatNumber(likes)}</span>
      </div>
      <div className="engagement-stat">
        <MessageCircle size={16} />
        <span>{formatNumber(comments)}</span>
      </div>
      <div className="engagement-stat">
        <Repeat2 size={16} />
        <span>{formatNumber(shares)}</span>
      </div>
    </div>
  );
});

const Post = memo(({ content, author, isAd, sponsor, userCount }) => {
  const [engagement, setEngagement] = useState(() => {
    const poissonRandom = (lambda) => {
      let L = Math.exp(-lambda);
      let k = 0;
      let p = 1;

      do {
        k++;
        p *= Math.random();
      } while (p > L);

      return k - 1;
    };

    const baseEngagementRate = isAd
      ? 0.00005
      : Math.min(0.1, 1 / Math.sqrt(userCount));
    const meanLikes = userCount * baseEngagementRate;
    const baseLikes = poissonRandom(meanLikes);
    const commentLambda = Math.max(baseLikes * 0.1, 0.1);
    const shareLambda = Math.max(baseLikes * 0.05, 0.05);

    return {
      likes: baseLikes,
      comments: poissonRandom(commentLambda),
      shares: poissonRandom(shareLambda),
    };
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setEngagement((prev) => {
        const growthRate = 1 + Math.random() * 0.01;
        return {
          likes: Math.floor(prev.likes * growthRate),
          comments: Math.floor(prev.comments * growthRate),
          shares: Math.floor(prev.shares * growthRate),
        };
      });
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`social-post ${isAd ? "sponsored" : ""}`}>
      {isAd && (
        <div className="sponsor-tag">
          <DollarSign size={14} />
          <span>Sponsored by {sponsor}</span>
        </div>
      )}
      <div className="post-header">
        <div className="post-author">{author}</div>
      </div>
      <div className="post-content">{content}</div>
      <PostEngagement {...engagement} />
    </div>
  );
});

const SocialFeed = ({ gameState }) => {
  const [posts, setPosts] = useState([]);
  const [lastPostTime, setLastPostTime] = useState(Date.now());
  const feedContentRef = useRef(null);

  useEffect(() => {
    if (!gameState || !gameState.isLaunched) {
      console.log("is launched: ", gameState.isLaunched);
      console.log("game state: ", gameState);
      return;
    }

    const postInterval = setInterval(() => {
      const currentTime = Date.now();
      const timeSinceLastPost = currentTime - lastPostTime;

      if (timeSinceLastPost >= 1000) {
        const postLikelihood =
          gameState.userCount <= 0
            ? 0
            : Math.min(1, (Math.log10(gameState.userCount) - 3) * 0.4 + 0.2);

        if (Math.random() < postLikelihood) {
          const newPost = generatePost(gameState);

          if (feedContentRef.current && feedContentRef.current.scrollTop < 50) {
            feedContentRef.current.scrollTo({
              top: 1,
              behavior: "smooth",
            });

            setTimeout(() => {
              setPosts((currentPosts) =>
                [newPost, ...currentPosts].slice(0, MAX_POSTS)
              );

              setTimeout(() => {
                feedContentRef.current?.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }, 50);
            }, 30);
          } else {
            setPosts((currentPosts) =>
              [newPost, ...currentPosts].slice(0, MAX_POSTS)
            );
          }

          setLastPostTime(currentTime);
        }
      }
    }, 100);

    return () => clearInterval(postInterval);
  }, [gameState, lastPostTime]);

  return (
    <div className="phone-container">
      <div className="phone-notch"></div>
      <StatusBar />
      <div className="phone-screen">
        <div className="social-feed">
          <div className="feed-header">
            <h2>{gameState.companyName}</h2>
          </div>
          <div className="feed-content" ref={feedContentRef}>
            {posts.map((post) => (
              <Post key={post.id} {...post} userCount={gameState.userCount} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialFeed;
